import React from "react"
import axios from "axios"
import { styled } from "@mui/material/styles"
import { css } from "@emotion/react"
import { StyledEngineProvider } from "@mui/material/styles"
import { Button } from "@mui/material"
import NotificationRow from "./NotificationRow"
import ThemeProviderWrapper from "./ThemeProviderWrapper"

const NotificationsFeedContainer = styled("div")`
  align-items: center;
  max-width: 100%;
`

const SFButton = styled(Button)`
  margin: 40px auto;
  width: 97%;
`

export default class NotificationsFeed extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      notifications: props.notifications || [],
      pagyMetadata: props.pagyMetadata || {},
      isLoading: false,
    }
  }

  componentDidMount() {
    if (this.state.notifications.length === 0) {
      this.getNotifications()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isActive &&
      !prevProps.isActive &&
      (this.state.currentPage !== prevState.currentPage ||
        this.state.notifications.length === 0)
    ) {
      this.getNotifications()
    }
  }

  getNotifications = async () => {
    const { currentPage } = this.state
    this.setState({ isLoading: true })
    axios.defaults.headers.common["Accept"] = "application/json"

    try {
      const response = await axios.get(`/notifications?page=${currentPage}`)
      this.setState((prevState) => ({
        notifications: [
          ...prevState.notifications,
          ...response.data.notifications,
        ],
        pagyMetadata: response.data.pagyMetadata,
        isLoading: false,
      }))
    } catch (error) {
      console.error("Error loading notifications.", error)
      this.setState({ isLoading: false })
    }
  }

  loadMore = () => {
    this.setState(
      (prevState) => ({
        currentPage: prevState.pagyMetadata.next,
      }),
      this.getNotifications
    )
  }

  renderNotifications = () => {
    const { currentUser } = this.props
    const { notifications } = this.state
    if (notifications.length === 0) {
      return (
        <div style={{ textAlign: "center" }}>You have no notifications.</div>
      )
    } else {
      return notifications.map((notification) => (
        <NotificationRow notification={notification} key={notification.id} currentUser={currentUser} />
      ))
    }
  }

  render() {
    const { pagyMetadata, isLoading } = this.state
    const loadMoreVisible =
      pagyMetadata.next && pagyMetadata.next <= pagyMetadata.last

    return (
      <ThemeProviderWrapper>
        <StyledEngineProvider injectFirst>
          <NotificationsFeedContainer>
            {this.renderNotifications()}
            {this.props.showLoadMore !== false && loadMoreVisible && (
              <div
                css={css`
                  display: flex;
                `}
              >
                <SFButton
                  onClick={this.loadMore}
                  disabled={isLoading}
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  {isLoading ? "Loading..." : "Load More"}
                </SFButton>
              </div>
            )}
          </NotificationsFeedContainer>
        </StyledEngineProvider>
      </ThemeProviderWrapper>
    )
  }
}
